<template>
    <upload :id="id" ref="file_upload" @uploaded="handleUpload" @filesToUpload="filesToUpload"></upload>
</template>

<script>
    export default {
        props: ['id'],
        components: {
            upload: require('./upload.vue').default,
        },
        methods: {
            handleUpload: function (data) {
                let json = jQuery.parseJSON(data);

                if (json.data.tags.length > 0) {
                    this.$emit('importedTags', json.data.tags);
                }

                this.$emit('uploadedFile', json.data.elements);
            },
            filesToUpload: function (count) {
                this.$emit('filesToUpload', count);
            }
        }
    }
</script>
